import { Controller } from "@hotwired/stimulus"
import { itemFromEvent, isFolder, controllerFor } from "./cloud_helpers"

// Menu al tasto destro su tessere e righe: le stesse voci del menu ⋯,
// adattate alla selezione (un file, una cartella, più elementi).
export default class extends Controller {
  static targets = ["menu", "download", "moveLabel", "deleteLabel"]

  open(event) {
    const item = itemFromEvent(event)
    if (!item || !this.hasMenuTarget) return
    event.preventDefault()
    const select = this.select
    if (select && !select.isSelected(item)) select.selectOnly(item)
    select?.focusItem(item)
    const items = select ? select.selectedItems : [item]
    this.configure(items, item)
    this.show(event.clientX, event.clientY)
  }

  configure(items, item) {
    const single = items.length === 1
    const folder = single && isFolder(item)
    const file = single && !folder
    const show = (name, on) => this.menuTarget.querySelectorAll(`[data-menu-item='${name}']`).forEach((el) => { el.hidden = !on })
    show("open", single)
    show("peek", file && !!item.dataset.peekUrl)
    show("download", file && !!item.dataset.downloadUrl)
    show("rename", single)
    show("sep", single)
    if (file && this.hasDownloadTarget) this.downloadTarget.href = item.dataset.downloadUrl
    const many = this.menuTarget.dataset
    if (this.hasMoveLabelTarget) this.moveLabelTarget.textContent = single ? many.moveOne : many.moveMany.replace("%{count}", items.length)
    if (this.hasDeleteLabelTarget) this.deleteLabelTarget.textContent = single ? many.deleteOne : many.deleteMany.replace("%{count}", items.length)
  }

  show(x, y) {
    const menu = this.menuTarget
    menu.hidden = false
    const { width, height } = menu.getBoundingClientRect()
    const left = Math.min(x, window.innerWidth - width - 8)
    const top = Math.min(y, window.innerHeight - height - 8)
    menu.style.left = `${Math.max(8, left)}px`
    menu.style.top = `${Math.max(8, top)}px`
    this.isOpen = true
    menu.querySelector("[role=menuitem]:not([hidden])")?.focus()
  }

  close(event) {
    if (!this.isOpen || !this.hasMenuTarget) return
    if (event?.type === "click" && this.menuTarget.contains(event.target) && event.target.closest("a[download]")) {
      // Lascia partire il download, poi chiudi.
    }
    this.menuTarget.hidden = true
    this.isOpen = false
  }

  keydown(event) {
    if (!this.isOpen) return
    if (event.key === "Escape") { event.preventDefault(); this.close() }
    if (event.key === "ArrowDown" || event.key === "ArrowUp") {
      const items = Array.from(this.menuTarget.querySelectorAll("[role=menuitem]:not([hidden])"))
      const index = items.indexOf(document.activeElement)
      const next = items[(index + (event.key === "ArrowDown" ? 1 : -1) + items.length) % items.length]
      event.preventDefault()
      event.stopPropagation()
      next?.focus()
    }
  }

  get select() { return controllerFor(this.element, "cloud-select") }
}
